module.exports = __webpack_public_path__ + "media/industry_tag_icon/biz_food-350346c0.png";